/* eslint-disable */
import { Component, memo } from "react";
import {  FormControl, FormLabel } from "@chakra-ui/react";
import { show } from "redux-modal";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { getEnums, getSections } from "../../utils/store/actions/survey.action";
import { BasicPicker } from "react-color-tools";
import {
  getFund,
  updateFund,
  getAllIssuerSigners,
  getAllProductSigners,
  getColors,
} from "../../utils/store/actions/funds.actions";
import {
  getFundEnvelopes,
  addDirectory,
} from "../../utils/store/actions/document.actions";
import {
  Button,
  Card,
  CardContent,
  Avatar,
  ListItemAvatar,
  Paper,
} from "@material-ui/core";

import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";
import { createStyles, Theme, withStyles } from "@material-ui/core/styles";
import { B4FSelect } from "../../components/component-questionnaire/B4FFields/B4FSelect";
import { B4FRadio } from "../../components/component-questionnaire/B4FFields/B4FRadio";
import { B4FText } from "../../components/component-questionnaire/B4FFields/B4FText";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import ModalManageDocument from "../../components/Modal/Modal.ManageDocument";
import ModalAddDocumentInDirectory from "../../components//Modal/Modal.AddDocumentInDirectory";
import Loading from "../../components/Share/Loading";
import { Select as SelectMultiple, MenuItem, Chip, Input } from "@material-ui/core";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 800,
    },
  },
};

const ColorPicker = memo((props: { availableColors: string[], color: string, onChange: (color: string) => void }) => {
  return (<BasicPicker
    swatches={props.availableColors}
    color={props.color}
    triangle={false}
    showTools={false}
    onChange={props.onChange}
  />);
});

const styles = (theme: Theme) =>
  createStyles({
    input: {
      "&:focus": {
        outline: "none !important",
        border: "1px solid red",
      },
    },
    divInput: {
      borderRadius: "5px",
    },
    fundCards: {
      borderRadius: "12px",
      maxWidth: "1200px",
      margin: "0 auto",
      display: "grid",
      gridGap: "1rem",
      [theme.breakpoints.up("lg")]: {
        gridTemplateColumns: "repeat(2, 1fr)",
      },
      [theme.breakpoints.up("xl")]: {
        gridTemplateColumns: "repeat(3, 1fr)",
      },
      "&:nth-child(1)": {
        paddingBottom: 0,
      },
    },
    backPageComponent: {
      display: "flex",
      alignItems: "center",
    },
    backButton: {
      borderRadius: "5px",
      backgroundColor: "white",
      margin: "1%",
    },
    backInput: {
      marginLeft: "3%",
      display: "flex",
      alignItems: "center",
    },
    card: {
      borderRadius: "12px",
      margin: "1%",
      border: "1px solid #EAEDF7",
      boxShadow:
        "0px 0px 1px rgba(44, 44, 44, 0.1), 0px 30px 40px rgba(175, 175, 175, 0.08)",
    },
    saveFund: {
      color: "white",
      textTransform: "none",
      backgroundColor: "#ae0064",
      width: "98%",
      margin: "0.5%",
      position: "sticky",
      bottom: 0,
      boxShadow:
        "rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px",
    },
    colorCards: {
      borderRadius: "12px",
      maxWidth: "1200px",
      margin: "0 auto",
      "&:nth-child(1)": {
        paddingBottom: 16,
      },
    },
    chip: {
      margin: 2,
    },
  });
class FundTab extends Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      preview: false,
      BANK_TRANSFER: false,
      CHEQUE: false,
      DEBIT: false,
      fund: {
        countryOfIncorporation: "",
        fundAbaNumber: "",
        fundAccountName: "",
        fundAccountNumber: "",
        fundAgreementNumber: "",
        fundBankAddress: "",
        fundBankCity: "",
        fundBankCountry: "",
        fundBankName: "",
        fundBankPostalCode: "",
        fundCurrencyReference: "",
        fundDescription: "",
        fundIban: "",
        fundSrri: "",
        fundSwiftBicCode: "",
        fundWarning: "",
        currency: "",
        isFundManagedByCompany: true,
        isMoralPersonFund: true,
        isOpened: true,
        withSubscriptionValidation: false,
        displayColor: "#5e72e4",
        paymentTypes: [""],
        person: {
          fundType: "",
        },
        productFamily: "",
        regulationAuthority: "",
      },
      toast: false,
    };
  }
  async componentDidMount() {
    await this.props.getColors();
    this.setState({ fund: this.props.Funds.fund });
    const fundPersonId = this.props.Funds.fund.person.id;
    await this.props.getAllIssuerSigners(fundPersonId);
    await this.props.getAllProductSigners(fundPersonId);
    await this.props.getFundEnvelopes(fundPersonId);
    await this.props.getSections("client").then(() => {
      this.props.Surveys.sections
        ?.find((section: any) => section.name === "document")
        ?.subSection?.find((sub: any) => sub.name === "person")
        ?.questions.map(
          (question: any) =>
            question.visibleCondition ===
            "getVal('person.personType')==='PRODUCT'" &&
            !this.props.Documents.fundDocument?.find(
              (e: any) => question.label === e.name
            ) &&
            !this.props.Documents.fundDocument?.find(
              (e: any) => question.label === e.name
            )?.isDeleted &&
            this.props
              .addDirectory(
                question.label,
                this.props.Funds.fund.person.id,
                "DIRECTORY_FUND",
                "default"
              )
              .then(() => this.props.getFundEnvelopes(fundPersonId))
        );
    });
  }

  handleBackPage = () => {
    window.location.href = `/admin/funds`;
  };
  handleChange = (e: any) => {
    if (e.id === "fundType") {
      this.setState({
        fund: {
          ...this.state.fund,
          person: {
            ...this.state.fund.person,
            fundType: e.value,
          },
        },
      });
    } else {
      this.setState({
        fund: {
          ...this.state.fund,
          [e.id || e.target?.id]:
            (e.value || e.target?.value) === "true"
              ? true
              : (e.value || e.target?.value) === "false"
                ? false
                : e.value || e.target?.value,
        },
      });
    }
  };

  handleSave = (e: any) => {
    this.props.updateFund(this.state.fund);
  };

  render() {
    const { Funds, Surveys } = this.props;
    const { fund } = Funds;
    const { classes } = this.props;
    const { t } = this.props;
    const array = [1, 2, 3, 4, 5, 6, 7];
    const colors = this.props.Funds?.colors;

    return this.state.fund && this.props.Documents && Surveys.enums ? (
      <div style={{ display: "flex" }}>
        <ModalAddDocumentInDirectory />
        {/* CONTENT */}
        <div className={classes.divInput}>
          {fund ? (
            <>
              <div style={{ margin: "1%", fontWeight: "bolder" }}>
                {t("LOGO")[0].toUpperCase() + t("LOGO").slice(1).toLowerCase()}
              </div>
              <Card className={classes.card}>
                <CardContent className={classes.colorCards}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                    }}
                  >
                    <ListItemAvatar>
                      <Avatar
                        style={{
                          backgroundColor:
                            this.state?.fund?.displayColor || colors[0]?.mainColor || "#4b0084",
                          marginTop: "15px",
                        }}
                        className={classes.avatar}
                      >
                        {this.state.fund?.nameInitials ||
                          `${this.props.Funds?.fund?.person?.name[0].toUpperCase()}${this.props.Funds?.fund?.person?.name[1].toUpperCase()}`}
                      </Avatar>
                    </ListItemAvatar>
                    <div
                      style={{
                        paddingLeft: "12px",
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <text>{t("INITIALS")}</text>
                      <Input
                        value={
                          this.state?.fund?.nameInitials ||
                          `${this.props.Funds?.fund?.person?.name[0].toUpperCase()}${this.props.Funds?.fund?.person?.name[1].toUpperCase()}`
                        }
                        onChange={(e) =>
                          this.setState({
                            fund: {
                              ...this.state.fund,
                              nameInitials: e.target.value,
                            },
                          })
                        }
                        type="text"
                        style={{
                          backgroundColor: "#fafcfe",
                          border: "1px solid #97A0C3",
                          width: "100px",
                          marginLeft: "0px",
                        }}
                      />
                    </div>

                    <div
                      style={{
                        paddingLeft: "12px",
                      }}
                    >

                      <div id="fundColorPicker" style={{ paddingTop: "2vh" }}>
                        <ColorPicker availableColors={colors?.map((color: any) => color.mainColor) || []} color={this.state.fund.displayColor || colors[0]?.mainColor} onChange={(color: any) => {
                          this.setState({
                            fund: {
                              ...this.state.fund,
                              displayColor: color,
                            },
                          });
                        }} />
                      </div>

                    </div>
                  </div>
                </CardContent>
              </Card>
              <div style={{ margin: "1%", fontWeight: "bolder" }}>
                {t("INFORMATIONS")[0].toUpperCase() +
                  t("INFORMATIONS").slice(1).toLowerCase()}
              </div>
              <Card className={classes.card}>
                <CardContent className={classes.fundCards}>
                  <B4FSelect
                    label="MAIN_CURRENCY"
                    value={this.state.fund.currency}
                    onBlur={console.log}
                    id="currency"
                    key="currency"
                    onChange={(e: any) => this.handleChange(e)}
                    options={Surveys?.enums["currency-codes"]}
                    isRequired={false}
                    visible={true}
                  />
                  <B4FSelect
                    label="IMMATRICULATION_COUNTRY"
                    onBlur={console.log}
                    onUpdate={console.log}
                    id="countryOfIncorporation"
                    key="countryOfIncorporation"
                    visible={true}
                    value={this.state?.fund?.countryOfIncorporation}
                    onChange={(e: any) => this.handleChange(e)}
                    options={Surveys?.enums["countries"]}
                  />
                  <B4FSelect
                    label="FUND_TYPE"
                    onBlur={console.log}
                    onUpdate={console.log}
                    id="fundType"
                    key="fundType"
                    visible={true}
                    value={this.state?.fund?.person?.fundType}
                    onChange={(e: any) => this.handleChange(e)}
                    options={Surveys?.enums["fund-types"]}
                  />

                  <B4FSelect
                    label="REGULATORY_AUTHORITY"
                    onBlur={console.log}
                    onUpdate={console.log}
                    id="regulationAuthority"
                    key="regulationAuthority"
                    visible={true}
                    value={this.state?.fund?.regulationAuthority}
                    onChange={(e: any) => this.handleChange(e)}
                    options={Surveys?.enums["authority-market"]}
                  />
                  <div>
                    <div style={{ paddingBottom: "10px" }}>
                      {t("RISK_LEVEL")}
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      {array.map((risk: any) => (
                        <div
                          id={risk}
                          onClick={(e: any) => {
                            this.setState({
                              fund: {
                                ...this.state.fund,
                                fundSrri: risk,
                              },
                              clicked: risk,
                            });
                          }}
                          style={{
                            width: "41px",
                            height: "31px",
                            padding: "5px",
                            backgroundColor:
                              this.state.clicked === risk ||
                                risk === this.state.fund?.fundSrri
                                ? "#4b0084"
                                : "#FAFCFE",
                            border: "1px solid #97A0C3",
                            fontWeight: "bold",
                            borderRadius: "5px",
                            display: "flex",
                            color: "#97A0C3",
                            justifyContent: "center",
                            alignContent: "center",
                          }}
                        >
                          {risk}
                        </div>
                      ))}
                    </div>
                  </div>
                  <B4FText
                    label="FUND_AGREEMENT_NUMBER"
                    value={this.state?.fund?.fundAgreementNumber}
                    id="fundAgreementNumber"
                    key="fundAgreementNumber"
                    onBlur={console.log}
                    placeholder=""
                    onChange={(e: any) => this.handleChange(e)}
                    visible={true}
                    isRequired={false}
                  />
                  <B4FRadio
                    label="IS_IT_AN_OPEN_FUND"
                    key="isOpened"
                    id="isOpened"
                    onChange={(e: any) => this.handleChange(e)}
                    options={[
                      { label: "YES_NO.YES", key: "true" },
                      { label: "YES_NO.NO", key: "false" },
                    ]}
                    value={
                      this.state?.fund?.isOpened === null ||
                        this.state?.fund?.isOpened === undefined
                        ? ""
                        : this.state?.fund?.isOpened.toString()
                    }
                    visible={true}
                  />
                  <B4FRadio
                    label="WITH_SUBSCRIPTION_VALIDATION"
                    key="withSubscriptionValidation"
                    id="withSubscriptionValidation"
                    onChange={(e: any) => this.handleChange(e)}
                    options={[
                      { label: "YES_NO.YES", key: "true" },
                      { label: "YES_NO.NO", key: "false" },
                    ]}
                    value={
                      this.state?.fund?.withSubscriptionValidation === null ||
                        this.state?.fund?.withSubscriptionValidation === undefined
                        ? ""
                        : this.state?.fund?.withSubscriptionValidation.toString()
                    }
                    visible={true}
                  />
                  <FormControl id="propertyPaymentType">
                    <FormLabel>{t('PAYMENT_TYPE')}</FormLabel>
                    <SelectMultiple
                      labelId="demo-mutiple-chip-label"
                      multiple
                      autoWidth
                      value={this.state?.fund?.paymentTypes || []}
                      onChange={(e: any, value: any) => {
                        this.setState({
                          fund: {
                            ...this.state.fund,
                            paymentTypes: e.target.value,
                          },
                        });
                      }}
                      renderValue={(selected: any) => (
                        <div className={classes.chips}>
                          {selected.map((value: any) => {
                            const label = Surveys?.enums["payment-types"]?.find((obj: any) => obj.key === value)?.label;
                            return (
                              <Chip
                                style={{ maxWidth: "200px", minWidth: "100px" }}
                                key={value}
                                label={
                                  label
                                    ? t("ENUMS." + label)
                                    : ""
                                }
                                className={classes.chip}
                              />
                            );
                          })}
                        </div>
                      )}
                      input={<Input id="select-multiple-chip" />}
                      MenuProps={MenuProps}
                    >
                      {Surveys?.enums && Surveys?.enums["payment-types"]?.map((obj: any) => {
                        return (
                          <MenuItem
                            id="payment-types"
                            key={obj.key}
                            value={obj.key}
                          >
                            {t("ENUMS." + obj?.label)}
                          </MenuItem>
                        );
                      })}
                    </SelectMultiple>
                  </FormControl>
                </CardContent>
              </Card>
              <div style={{ margin: "1%", fontWeight: "bolder" }}>
                {t("DOCUMENTS")}
              </div>
              <ModalManageDocument />
              {!this.props.Documents.fundDocument ? (
                <Card className={classes.card}>
                  <CardContent
                    className={classes.colorCards}
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      padding: 0,
                    }}
                  >
                    <Button
                      style={{
                        textTransform: "none",
                        border: "1px solid #ae0064",
                        color: "#ae0064",
                        borderRadius: "12px",
                        margin: "1%",
                        minWidth: "250px",
                      }}
                    >
                      <Loading />
                    </Button>
                  </CardContent>
                </Card>
              ) : this.props.Documents.fundDocument &&
                this.props.Documents.fundDocument.length !== 0 &&
                this.props.Documents.fundDocument?.some(
                  (doc: any) => doc.isDeleted === false
                ) ? (
                <Card className={classes.card}>
                  <CardContent
                    className={classes.colorCards}
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      padding: 0,
                    }}
                  >
                    <Button
                      style={{
                        textTransform: "none",
                        border: "1px solid #ae0064",
                        color: "#ae0064",
                        borderRadius: "12px",
                        margin: "1%",
                        minWidth: "250px",
                      }}
                      onClick={(e: any) =>
                        this.props.show("manage_document", {
                          name: "manage_document",
                          history,
                          actionDone: "DIRECTORY_FUND",
                        })
                      }
                    >
                      {t("MANAGE_DIRECTORIES")}
                    </Button>
                  </CardContent>
                </Card>
              ) : (
                (this.props.Documents.fundDocument.length === 0 ||
                  !this.props.Documents.fundDocument) && (
                  <Card className={classes.card}>
                    <CardContent
                      className={classes.colorCards}
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        padding: 0,
                      }}
                    >
                      <Button
                        style={{
                          textTransform: "none",
                          border: "1px solid #ae0064",
                          color: "#ae0064",
                          borderRadius: "12px",
                          margin: "1%",
                          minWidth: "250px",
                        }}
                        onClick={(e: any) =>
                          this.props.show("add_doc_directory", {
                            name: "add_doc_directory",
                            history,
                            actionDone: "DIRECTORY_FUND",
                            parentDirectoryId: this.props.Funds.fund.person.id,
                          })
                        }
                      >
                        <AddCircleOutlineIcon
                          style={{
                            color: "#ae0064",
                            marginRight: "20px",
                          }}
                        />
                        {t("ADD_DOCUMENT_OR_FOLDER")}
                      </Button>
                    </CardContent>
                  </Card>
                )
              )}
              <div style={{ margin: "1%", fontWeight: "bolder" }}>
                {t("BANK_ACCOUNT")}
              </div>
              <Card className={classes.card}>
                <CardContent className={classes.fundCards}>
                  <B4FText
                    label="FUND_BANK_NAME"
                    value={this.state?.fund?.fundBankName}
                    id="fundBankName"
                    key="fundBankName"
                    onBlur={console.log}
                    placeholder=""
                    onChange={(e: any) => this.handleChange(e)}
                    visible={true}
                    isRequired={false}
                  />
                  <B4FText
                    label="IBAN"
                    value={this.state?.fund?.fundIban}
                    id="fundIban"
                    key="fundIban"
                    onBlur={console.log}
                    placeholder=""
                    onChange={(e: any) => this.handleChange(e)}
                    visible={true}
                    isRequired={false}
                  />
                  <B4FText
                    label="ACCOUNT_NAME"
                    value={this.state?.fund?.fundAccountName}
                    id="fundAccountName"
                    key="fundAccountName"
                    onBlur={console.log}
                    placeholder=""
                    onChange={(e: any) => this.handleChange(e)}
                    visible={true}
                    isRequired={false}
                  />
                  <B4FText
                    label="FUND_BANK_ADDRESS"
                    value={this.state?.fund?.fundBankAddress}
                    id="fundBankAddress"
                    key="fundBankAddress"
                    onBlur={console.log}
                    placeholder=""
                    onChange={(e: any) => this.handleChange(e)}
                    visible={true}
                    isRequired={false}
                  />
                  <B4FText
                    label="FUND_ACCOUNT_NUMBER"
                    value={this.state?.fund?.fundAccountNumber}
                    id="fundAccountNumber"
                    key="fundAccountNumber"
                    onBlur={console.log}
                    placeholder=""
                    onChange={(e: any) => this.handleChange(e)}
                    visible={true}
                    isRequired={false}
                  />
                  <B4FText
                    label="FUND_BANK_CITY"
                    value={this.state?.fund?.fundBankCity}
                    id="fundBankCity"
                    key="fundBankCity"
                    onBlur={console.log}
                    placeholder=""
                    onChange={(e: any) => this.handleChange(e)}
                    visible={true}
                    isRequired={false}
                  />
                  <B4FText
                    label="FUND_SWIFT_BIC_CODE"
                    value={this.state?.fund?.fundSwiftBicCode}
                    id="fundSwiftBicCode"
                    key="fundSwiftBicCode"
                    onBlur={console.log}
                    placeholder=""
                    onChange={(e: any) => this.handleChange(e)}
                    visible={true}
                    isRequired={false}
                  />
                  <B4FText
                    label="FUND_BANK_POSTAL_CODE"
                    value={this.state?.fund?.fundBankPostalCode}
                    id="fundBankPostalCode"
                    key="fundBankPostalCode"
                    onBlur={console.log}
                    placeholder=""
                    onChange={(e: any) => this.handleChange(e)}
                    visible={true}
                    isRequired={false}
                  />
                  <B4FText
                    label="FUND_ABA_NUMBER"
                    value={this.state?.fund?.fundAbaNumber}
                    id="fundAbaNumber"
                    key="fundAbaNumber"
                    onBlur={console.log}
                    placeholder=""
                    onChange={(e: any) => this.handleChange(e)}
                    visible={true}
                    isRequired={false}
                  />
                  <B4FSelect
                    label="FUND_BANK_COUNTRY"
                    onBlur={console.log}
                    onUpdate={console.log}
                    id="fundBankCountry"
                    key="fundBankCountry"
                    visible={true}
                    value={this.state?.fund?.fundBankCountry}
                    onChange={(e: any) => this.handleChange(e)}
                    options={Surveys?.enums["countries"]}
                  />
                </CardContent>
              </Card>
              <Button
                variant="contained"
                className={classes.saveFund}
                onClick={(e) => this.handleSave(e)}
              >
                {t("SAVE")}
              </Button>
            </>
          ) : (
            <></>
          )}
        </div>
      </div>
    ) : (
      <Paper className={classes.paper}>
        <Loader
          type="ThreeDots"
          color="#4B0084"
          height={100}
          width={100}
          timeout={3000} //3 secs
        />
      </Paper>
    );
  }
}

const mapStateToProps = (state: any) => ({
  ...state,
});

const mapDispatchToProps = {
  getFund,
  updateFund,
  show,
  getEnums,
  getAllIssuerSigners,
  getAllProductSigners,
  getFundEnvelopes,
  getSections,
  addDirectory,
  getColors
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(withStyles(styles)(FundTab)));
